<template>
  <AdminFieldWrapper :label="label || ''">
    <AdminInputRelated
      v-bind="{ ...$attrs, ...$props }"
      v-on="$listeners"
      btn-outlined
    />
  </AdminFieldWrapper>
</template>

<script>
import { Model } from '@vuex-orm/core'
import AdminInputRelated from '@/components/AdminInputRelated'
import AdminFieldWrapper from '@/components/AdminFieldWrapper'
export default {
  name: 'AdminFieldRelated',
  components: { AdminInputRelated, AdminFieldWrapper },
  props: {
    Model: {
      type: Model,
      default: () => Model,
    },
    id: {
      type: [String, Number],
      default: null,
    },
    label: {
      type: String,
      deftault: null,
    },
  },
  data() {
    return {}
  },
  methods: {
    update(fields) {
      this.Model.update({ where: this.id, data: fields })
    }, // update
  },
}
</script>
